import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { isEmpty } from 'lodash';
import { loadState, saveState } from './states';
import rootReducer from '../../reducers';
import { updateToken } from '../../actions/tokenAction';
import setAuthorisationToken from '../../services/setAuthorisationToken';

const store = createStore(
  rootReducer,
  loadState(),
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

store.subscribe(() => {
  saveState({
    ...store.getState(),
  });
});

if (!isEmpty(store.getState().token)) {
  setAuthorisationToken(store.getState().token);
  store.dispatch(updateToken());
} else {
  setAuthorisationToken(false);
}

export default store;
